import React from 'react';
import '../styles/global.css';

const YOUTUBE_CHANNEL_URL = 'https://www.youtube.com/@ASCENSOSAPPVORTEX/playlists';

const Tutorials = () => {
    return (
        <div className="tutorials-container" style={{ padding: '20px', color: 'var(--text-primary)' }}>
            <h1 style={{ color: 'var(--accent)', marginBottom: '8px', fontSize: '1.4rem' }}>Video Tutoriales</h1>
            <p style={{ opacity: 0.7, marginBottom: '16px', fontSize: '0.9rem' }}>
                Aprende a sacar el máximo provecho de Ascensos App.
            </p>

            <div style={{
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'center',
                gap: '12px',
                padding: '16px',
                background: 'var(--bg-secondary)',
                border: '1px solid rgba(255, 255, 255, 0.08)',
                borderRadius: '10px'
            }}>
                <a
                    href={YOUTUBE_CHANNEL_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '8px',
                        padding: '10px 18px',
                        background: 'var(--accent)',
                        color: '#0a192f',
                        fontWeight: 'bold',
                        fontSize: '0.9rem',
                        borderRadius: '50px',
                        textDecoration: 'none'
                    }}
                >
                    Ver tutoriales en YouTube
                </a>
                <span style={{ fontSize: '0.8rem', opacity: 0.6 }}>
                    Se abre en una pestaña nueva.
                </span>
            </div>
        </div>
    );
};

export default Tutorials;
